import { Routes, Route } from 'react-router-dom'
import HomePage from '@/pages/HomePage.jsx'
import RoomPage from '@/pages/RoomPage.jsx'
import NotFoundPage from '@/pages/NotFoundPage.jsx'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/room/:roomId" element={<RoomPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
